const getMfaOption = (mfaData) => mfaData.get("option");
const getMfaRequired = (mfaData) => mfaData.get("required");

export { getMfaOption, getMfaRequired };
